import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_current_dock_appointments_by_lookupcodeService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lookupcode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, DockAppointmentsOrdersLookup?: { OrderId?: number }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_current_dock_appointments_by_lookupcode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lookupcode: string    }) {
        if(isNil(inParams.lookupcode)) {
          return true; 
        }
      return false;
    }
}
